<template>
  <v-navigation-drawer
    v-model="showingMenu"
    app
    clipped
    disable-resize-watcher
    class="pulaMapa"
    width="170"
    mini-variant
  >
    <v-list>
      <v-list-item id="goDashboard" to="/">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" text="Lote Produção">fas fa-tachometer-alt</v-icon>
          </template>
          <span>Dashboard</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item class="pa-0">
        <v-menu :close-on-content-click="true" offset-x>
          <template v-slot:activator="{ on }">
            <v-btn
              color="#10303D"
              id="goTo"
              text
              v-on="on"
              style="padding: 0px; width: 100%; height: 50px;"
            >
              <v-icon>fas fa-globe</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item id="goGeoMortalidade" to="/geoMortalidade">
              <v-list-item-icon>
                <v-icon>fas fa-map-marked-alt</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Mortalidade</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goGeoAlojamento" to="/geoAlojamento">
              <v-list-item-icon>
                <v-icon>fas fa-map</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Alojamento</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goGeoEstabelecimento" to="/geoEstabelecimento">
              <v-list-item-icon>
                <v-icon>fas fa-map-pin</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Estabelecimentos por município</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-list-item>
      <v-list-item id="goLoteProducao" to="/loteProducaoSearch">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" text="Lote Produção">fas fa-piggy-bank</v-icon>
          </template>
          <span>Lote de Produção</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item class="pa-0">
        <v-menu :close-on-content-click="true" offset-x>
          <template v-slot:activator="{ on,  attrs}">
                <v-btn
                  color="#10303D"
                  id="goTo"
                  text
                  v-on="on"
                  style="padding: 0px; width: 100%; height: 50px;"
                >
                  <v-icon>fas fa-truck</v-icon>
                </v-btn>
              <span>Alojamento e Abate</span>
          </template>
          <v-list>
            <v-list-item id="goPlanejamentoAlojamento" to="/planejamentoAlojamento">
              <v-list-item-icon>
                <v-icon>fas fa-clipboard-list</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Planejamento de Alojamento</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goProgramacaoAbate" to="/programacaoAbate">
              <v-list-item-icon>
                <v-icon>fas fa-clipboard-check</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Programação de Abate</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-list-item>
      <v-list-item id="goPedidos" to="/pedidosRacao" v-if="$vuetify.breakpoint.mdAndUp">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" text="Lote Produção">fas fa-dolly</v-icon>
          </template>
          <span>Pedidos de Ração</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item v-show="cdEmpresa !== 4" id="goBoletimSanitario"
                   to="/pesquisaBoletimSanitario" style="padding-left: 20px;">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" text="Boletim Sanitário">fas fa-file-medical</v-icon>
          </template>
          <span>Boletim Sanitário</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item class="pa-0">
        <v-menu :close-on-content-click="true" offset-x>
          <template v-slot:activator="{ on }">
            <v-btn
              color="#10303D"
              id="goTo"
              text
              v-on="on"
              style="padding: 0px; width: 100%; height: 50px;"
            >
              <v-icon>fas fa-poll</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item id="goAnaliseMortalidadeCausa" to="/causaMortalidade">
              <v-list-item-icon>
                <v-icon>fas fa-chart-pie</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Mortalidade por Causa</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goAnaliseMortalidadeDistribuicao" to="/ditribuicaoMortalidade">
              <v-list-item-icon>
                <v-icon>fas fa-chart-bar</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Distribuição de Mortalidade</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              id="goAnaliseMortalidadePeriodoFechamento"
              to="/analiseMortalidadePeriodoFechamento"
            >
              <v-list-item-icon>
                <v-icon>fas fa-chart-area</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Mortalidade por Período de Fechamento</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goAnaliseConsumoRacao" to="/analiseConsumoRacao">
              <v-list-item-icon>
                <v-icon>fas fa-chart-line</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Consumo de Ração</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goControleSanitarioMortalidade" to="/controleMortalidade">
              <v-list-item-icon>
                <v-icon>fas fa-notes-medical</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Controle Sanitário de Mortalidade</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-list-item>
      <v-list-item class="pa-0">
        <v-menu :close-on-content-click="true" offset-x>
          <template v-slot:activator="{ on }">
            <v-btn
              color="#10303D"
              id="goTo"
              text
              v-on="on"
              style="padding: 0px; width: 100%; height: 50px;"
            >
              <v-icon>fas fa-copy</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-show="cdEmpresa !== 6" id="goRelatorioPropriedadesAtivas" to="/relatorioPropriedadesAtivas">
              <v-list-item-icon>
                <v-icon>fas fa-building</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Relatório de Propriedades Ativas</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-show="cdEmpresa !== 4" id="goRelatorioAnimaisGerenciados" to="/relatorioAnimaisGerenciados">
              <v-list-item-icon>
                <v-icon>fas fa-building</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Relatório de Animais Gerenciados</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-list-item>
      <v-list-item class="pa-0">
        <v-menu :close-on-content-click="true" offset-x>
          <template v-slot:activator="{ on }">
            <v-btn
              color="#10303D"
              id="goTo"
              text
              v-on="on"
              style="padding: 0px; width: 100%; height: 50px;"
            >
              <v-icon>fas fa-cog</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item id="goEstabelecimento" to="/estabelecimentoSearch">
              <v-list-item-icon>
                <v-icon>fas fa-building</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Estabelecimento</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goExtensionista" to="/tecnicoSearch">
              <v-list-item-icon>
                <v-icon>fas fa-user-md</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Extensionista</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goRacao" to="/racaoSearch">
              <v-list-item-icon>
                <v-icon>mdi-corn</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Ração</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goFarmaco" to="/farmacoSearch">
              <v-list-item-icon>
                <v-icon>fas fa-syringe</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Medicamento</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goLaboratorio" to="/laboratorioSearch">
              <v-list-item-icon>
                <v-icon>fas fa-flask</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Laboratório</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goPrincipioAtivo" to="/principioAtivoSearch">
              <v-list-item-icon>
                <v-icon>fas fa-mortar-pestle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Princípio Ativo</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goFabricaRacao" to="/fabricaRacaoSearch">
              <v-list-item-icon>
                <v-icon>fas fa-industry</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Fábrica de Ração</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goPlantaAbate" to="/plantaAbateSearch">
              <v-list-item-icon>
                <v-icon>fas fa-warehouse</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Planta de Abate</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goMotivoBaixa" to="/motivoBaixaSearch">
              <v-list-item-icon>
                <v-icon>fas fa-book-dead</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Motivo de Mortalidade</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goConsumoRacao" to="/tabelaConsumoRacaoSearch">
              <v-list-item-icon>
                <v-icon>fas fa-th-list</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Consumo de Ração</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goTabelaCrescimento" to="/tabelaCrescimentoAnimal">
              <v-list-item-icon>
                <v-icon>fas fa-th-list</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Crescimento Animal</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item id="goLimiteMortalidade" to="/tabelaLimiteMortalidadeSearch">
              <v-list-item-icon>
                <v-icon>fas fa-th-list</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Limite de Mortalidade</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/feeding">
              <v-list-item-icon>
                <v-icon>fas fa-th-list</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Arraçoamento</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/producers-without-access">
              <v-list-item-icon>
                <v-icon>fas fa-user-slash</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Produtores sem acesso</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/mercadoDestino">
              <v-list-item-icon>
                <v-icon>fas fa-dolly-flatbed</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Mercado destino</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      items: [],
    };
  },
  model: {
    prop: "value",
    event: "input",
  },
  computed: {
    showingMenu: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    cdEmpresa() {
      return this.$keycloak['tokenParsed']["PARTNERID"]
    }
  },
  methods: {},
};
</script>

<style scoped>
.pulaMapa {
  z-index: 1200;
}
</style>
